<template>
    <div class="info-container">
        <div class="info-title">
            <span>Country,Destination, Rate, Transit time, Remark</span>
        </div>
        <div class="info-content">
            <!-- :header-cell-style="{backgroundColor:'rgb(254, 123, 0)',color:'#fff'}" -->
            <el-table border
                      row-key="id"
                      :data="info">
                <el-table-column align="center"
                                 label="sortNo">
                    <template slot-scope="scoped">
                        <el-input class="sort-no"
                                  type="number"
                                  min="0"
                                  max="999999999"
                                  v-model="scoped.row.sortNo"
                                  @blur="sortInputBlur(scoped.row)"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="Country"
                                 prop="countryEN"></el-table-column>
                <el-table-column label="Destination"
                                 prop="destinationEN"></el-table-column>
                <el-table-column label="Rate"
                                 prop="rate"></el-table-column>
                <el-table-column label="Transit Time"
                                 prop="transitTimeEN"></el-table-column>
                <el-table-column label="Remark"
                                 min-width="130"
                                 prop="remarkEN"></el-table-column>
                <el-table-column label="Operation"
                                 align="center">
                    <template slot-scope="scoped">
                        <span class="icon-edit-del"
                              @click="showEditDialog(scoped.row)"><i class="el-icon-edit"></i></span>
                        <span class="icon-edit-del"
                              @click="showDelDialog(scoped.row)"><i class="el-icon-delete"></i></span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- <button class="addBtn">Add</button> -->
            <el-button type="primary"
                       @click="showAddDialog"
                       style="margin-top:10px">Add</el-button>
        </div>

        <el-dialog title="Multi-Language"
                   :visible.sync="editInfoDialogVisible"
                   :close-on-click-modal="false"
                   @close="editInfoDialogClose"
                   width="50%">
            <el-form ref="form"
                     label-position="top"
                     :model="form">
                <div class="content">
                    <el-tabs v-model="activeName"
                             @tab-click="changePane">
                        <el-tab-pane label="Country"
                                     name="Country">
                            <el-form-item prop="countryId"
                                          label="English:"
                                          :rules="[{required:true,message:'Country is required'}]">
                                <el-select v-model="form.countryId">
                                    <el-option v-for="(item,index) in countryList"
                                               :key="index"
                                               :label="item.nameEN"
                                               :value="item.id">{{item.nameEN}}</el-option>
                                </el-select>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="Destination"
                                     name="Destination">
                            <el-form-item prop="destENDia"
                                          label="English:"
                                          :rules="[{required:true,message:'Destination is required',pattern: '[^ \x22]+' },{max:100,message:'Limited 100 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.destENDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                            <el-form-item prop="destCNDia"
                                          label="Chinese:"
                                          :rules="[{required:true,message:'Destination is required',pattern: '[^ \x22]+' },{max:100,message:'Limited 100 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.destCNDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                            <el-form-item prop="destFRDia"
                                          label="French:"
                                          :rules="[{required:true,message:'Destination is required',pattern: '[^ \x22]+' },{max:100,message:'Limited 100 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.destFRDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                            <el-form-item prop="destARDia"
                                          label="Arabic:"
                                          :rules="[{required:true,message:'Destination is required',pattern: '[^ \x22]+' },{max:100,message:'Limited 100 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.destARDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                             <el-form-item prop="destURDia"
                                          label="Urdu:"
                                          :rules="[{required:true,message:'Destination is required',pattern: '[^ \x22]+' },{max:100,message:'Limited 100 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.destURDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="Rate"
                                     name="third">
                            <el-form-item prop="rateENDia"
                                          label="English:"
                                          :rules="[{required:true,message:'Rate is required'}]">
                                <el-input-number v-model="form.rateENDia"></el-input-number>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="Transit Time"
                                     name="fourth">
                            <el-form-item prop="transENDia"
                                          label="English:"
                                          :rules="[{required:true,message:'Transit Time is required',pattern: '[^ \x22]+' },{max:50,message:'Limited 50 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.transENDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                            <el-form-item prop="transCNDia"
                                          label="Chinese:"
                                          :rules="[{required:true,message:'Transit Time is required',pattern: '[^ \x22]+' },{max:50,message:'Limited 50 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.transCNDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                            <el-form-item prop="transFRDia"
                                          label="French:"
                                          :rules="[{required:true,message:'Transit Time is required',pattern: '[^ \x22]+' },{max:50,message:'Limited 50 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.transFRDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                             <el-form-item prop="transARDia"
                                          label="Arabic:"
                                          :rules="[{required:true,message:'Transit Time is required',pattern: '[^ \x22]+' },{max:50,message:'Limited 50 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.transARDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                              <el-form-item prop="transURDia"
                                          label="Urdu:"
                                          :rules="[{required:true,message:'Transit Time is required',pattern: '[^ \x22]+' },{max:50,message:'Limited 50 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.transURDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                        </el-tab-pane>
                        <el-tab-pane label="Remark"
                                     name="remark">
                            <el-form-item prop="remarkENDia"
                                          label="English:"
                                          :rules="[{required:true,message:'Remark is required',pattern: '[^ \x22]+' },{max:500,message:'Limited 500 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.remarkENDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                            <el-form-item prop="remarkCNDia"
                                          label="Chinese:"
                                          :rules="[{required:true,message:'Remark is required',pattern: '[^ \x22]+'},{max:500,message:'Limited 500 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.remarkCNDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                            <el-form-item prop="remarkFRDia"
                                          label="French:"
                                          :rules="[{required:true,message:'Remark is required',pattern: '[^ \x22]+'},{max:500,message:'Limited 500 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.remarkFRDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                             <el-form-item prop="remarkARDia"
                                          label="Arabic:"
                                          :rules="[{required:true,message:'Remark is required',pattern: '[^ \x22]+'},{max:500,message:'Limited 500 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.remarkARDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                              <el-form-item prop="remarkURDia"
                                          label="Urdu:"
                                          :rules="[{required:true,message:'Remark is required',pattern: '[^ \x22]+'},{max:500,message:'Limited 500 characters',trigger:'blur'}]">
                                <el-input type="textarea"
                                          v-model="form.remarkURDia"
                                          :rows="3"></el-input>
                            </el-form-item>
                        </el-tab-pane>
                    </el-tabs>

                </div>
            </el-form>
            <span slot="footer"
                  class="dialog-footer">
                <el-button @click="dialogCancel">Cancel</el-button>
                <el-button type="primary"
                           :disabled="btnDisabled"
                           @click="confirmClick">Confirm</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import Sortable from 'sortablejs'
import api from '@api/cooperation'
export default {
    data () {
        return {
            info: [],
            editInfoDialogVisible: false,
            activeName: 'Country',
            English: '123',
            countryEN: '',
            countryCN: '',
            countryFR: '',
            countryAR: '',
            countryUR: '',
            destCN: '',
            destEN: '',
            destFR: '',
            destAR: '',
            destUR: '',
            rateCN: '',
            rateEN: '',
            rateFR: '',
            rateAR: '',
            rateUR: '',
            transCN: '',
            transEN: '',
            transFR: '',
            transAR: '',
            transUR: '',
            remarkCN: '',
            remarkEN: '',
            remarkFR: '',
            remarkAR: '',
            remarkUR: '',

            form: {
                id: null,
                destCNDia: '',
                destENDia: '',
                destFRDia: '',
                destARDia: '',
                destURDia: '',
                rateENDia: 0,
                transCNDia: '',
                transENDia: '',
                transFRDia: '',
                transARDia: '',
                transURDia: '',
                remarkCNDia: '',
                remarkENDia: '',
                remarkFRDia: '',
                remarkARDia: '',
                remarkURDia: '',
                countryId: '',
                sortNo: 0,
            },
            countryList: [],
            tag: '',
            btnDisabled: false
        }
    },
    methods: {
        changePane () {

        },
        dialogCancel () {
            this.editInfoDialogVisible = false
            this.$refs.form.resetFields()
            this.activeName = 'Country'
        },
        showAddDialog () {
            this.tag = 'add'
            this.fetchAllCountryList()
            this.editInfoDialogVisible = true
        },
        showEditDialog (row) {
            this.tag = 'edit'
            this.fetchAllCountryList()
            this.editInfoDialogVisible = true

            this.$nextTick(() => {
                this.form.id = row.id
                this.form.sortNo = row.sortNo
                this.form.countryId = row.countryId
                this.form.destENDia = row.destinationEN
                this.form.destCNDia = row.destinationCN
                this.form.destFRDia = row.destinationFR
                this.form.destARDia = row.destinationAR
                this.form.destURDia = row.destinationUR
                this.form.rateENDia = row.rate
                this.form.transENDia = row.transitTimeEN
                this.form.transCNDia = row.transitTimeCN
                this.form.transFRDia = row.transitTimeFR
                this.form.transARDia = row.transitTimeAR
                this.form.transURDia = row.transitTimeUR
                this.form.remarkENDia = row.remarkEN
                this.form.remarkCNDia = row.remarkCN
                this.form.remarkFRDia = row.remarkFR
                this.form.remarkARDia = row.remarkAR
                this.form.remarkURDia = row.remarkUR

            })
        },
        async showDelDialog (row) {
            const ctx = await this.$confirm('This action will permanently delete the info and whether to continue?', 'Tip', {
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).catch(err => {
                this.$message.info('Cancel delete')
            })
            if (ctx == 'confirm') {
                const res = await api.delRateById({ id: row.id })
                if (res.success == true) {
                    this.fetchInfoList()
                }
            }
        },
        async fetchInfoList () {
            const res = await api.queryRate()
            this.info = res.data
        },
        async fetchAllCountryList () {
            const res = await api.queryAllCountryList()
            if (res.success == true) {
                this.countryList = res.data
            }
        },
        async confirmClick () {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    let res;
                    this.btnDisabled = true
                    if (this.tag == 'add') {
                         let params = {
                        "countryId": this.form.countryId,
                        "destinationCN": this.form.destCNDia,
                        "destinationEN": this.form.destENDia,
                        "destinationFR": this.form.destFRDia,
                        "destinationAR": this.form.destARDia,
                        "destinationUR": this.form.destURDia,
                        "rate": this.form.rateENDia,
                        "remarkCN": this.form.remarkCNDia,
                        "remarkEN": this.form.remarkENDia,
                        "remarkFR": this.form.remarkFRDia,
                        "remarkAR": this.form.remarkARDia,
                        "remarkUR": this.form.remarkURDia,
                        "sortNo": this.form.sortNo,
                        "transitTimeCN": this.form.transCNDia,
                        "transitTimeEN": this.form.transENDia,
                        "transitTimeFR": this.form.transFRDia,
                        "transitTimeAR": this.form.transARDia,
                        "transitTimeUR": this.form.transURDia,
                    }
                        api.addRate(params).then(() => {
                            this.btnDisabled = false
                            this.editInfoDialogVisible = false
                            this.$refs.form.resetFields()
                            this.fetchInfoList()
                        }).catch(() => {
                            this.btnDisabled = false
                        })
                    } else {
                         let params = {
                        "countryId": this.form.countryId,
                        "destinationCN": this.form.destCNDia,
                        "destinationEN": this.form.destENDia,
                        "destinationFR": this.form.destFRDia,
                        "destinationAR": this.form.destARDia,
                        "destinationUR": this.form.destURDia,
                        "id": this.form.id,
                        "rate": this.form.rateENDia,
                        "remarkCN": this.form.remarkCNDia,
                        "remarkEN": this.form.remarkENDia,
                        "remarkFR": this.form.remarkFRDia,
                        "remarkAR": this.form.remarkARDia,
                        "remarkUR": this.form.remarkURDia,
                        "sortNo": this.form.sortNo,
                        "transitTimeCN": this.form.transCNDia,
                        "transitTimeEN": this.form.transENDia,
                        "transitTimeFR": this.form.transFRDia,
                        "transitTimeAR": this.form.transARDia,
                        "transitTimeUR": this.form.transURDia,
                    }
                        api.updateRate(params).then(() => {
                            this.btnDisabled = false
                            this.editInfoDialogVisible = false
                            this.$refs.form.resetFields()
                            this.fetchInfoList()
                        }).catch(() => {
                            this.btnDisabled = false
                        })
                    }
                }
            })
        },
        editInfoDialogClose () {
            this.editInfoDialogVisible = false
            this.$refs.form.resetFields()
            this.activeName = 'Country'
        },
        async sortInputBlur (row) {
            if (row.sortNo < 0 || row.sortNo > 999999999) {
                this.fetchInfoList()
                return this.$message.error('Please input value 0~999999999 ')
            }
            let params = {
                sortNo: row.sortNo,
                id: row.id
            }
            const res = await api.updateSortById(params)
            if (!res.success) {
                this.$message.error('Update sortNo error')
            }

        }
    },
    mounted () {
        // const table = document.querySelector('.el-table__body-wrapper tbody')
        // const self = this
        // Sortable.create(table, {
        //     onEnd ({ newIndex, oldIndex }) {
        //         const targetRow = self.info.splice(oldIndex, 1)[0]
        //         self.info.splice(newIndex, 0, targetRow)
        //     }
        // })
        this.fetchInfoList()
    }
}
</script>
<style scoped>
.info-container {
    margin-bottom: 20px;
    margin-top: 50px;
    margin-left: 250px;
}
.info-title {
    padding: 20px;
    font-size: 22px;
    font-weight: 700;
    padding-left: 70px;
}
.info-content {
    margin-left: 70px;
}
.el-form--label-top >>> .el-form-item__label {
    padding: 0px;
}
.addBtn {
    border: none;
    width: 70px;
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    color: #fff;
    margin-top: 10px;
    background-color: #fe7b00;
    border-radius: 5px;
    box-shadow: 2px 2px 2px #ccc;
}

.info-container >>> .el-dialog__header {
    text-align: center;
    font-size: 18px;
    font-weight: 700;
    border-bottom: 1px solid #eee;
}
.info-container >>> .el-dialog__body {
    padding-top: 10px;
}
.info-container >>> .el-form-item__content {
    margin-bottom: 20px;
}
.info-container >>> .el-dialog__footer {
    text-align: center;
}
.multi-title {
    font-size: 18px;
    margin: 20px 0 10px 0;
}
.icon-edit-del {
    margin-left: 10px;
}
.sort-no >>> .el-input__inner {
    width: 50%;
    padding: 0px 5px;
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/info.vue